export default __webpack_public_path__ + "static/media/640_business01-en-mobile.fd5061c6.png";